import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";
import { baseURL } from "../../services/axios/eps";
import { updateReviewStatus } from "../../services/axios/apiManager";
import { toast } from "sonner";
import { useState } from "react";
import LoadingSpinner from "../../Components/spinner";
const ReviewEditModal = ({
  selectedReview,
  setSelectedReview,
  openDetailsModal,
  setOpenDetailsModal,
  fetchReviews,
  pagination,
}) => {
  const [changing, setChanging] = useState(false);
  const handleCloseDetailsModal = () => {
    setSelectedReview(null);
    setOpenDetailsModal(false);
  };

  const handleUpdateReviewStatus = async (newStatus) => {
    setChanging(true);
    const data = {
      id: selectedReview?.id,
      status: newStatus,
    };
    const res = await updateReviewStatus(data);
    if (res?.data?.success) {
      setSelectedReview((prev) => ({ ...prev, status: newStatus }));
      await fetchReviews(pagination);
      toast.success(`Status set to ${newStatus} successfuly`, {
        duration: 2000,
      });
    } else {
      toast.error(`Error upon updating status, try again`, { duration: 2000 });
    }
    setChanging(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Game Review</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <div className="d-flex justify-content-center">
          {selectedReview?.logo && (
            <img
              crossorigin="anonymous"
              src={`${baseURL}/uploads/file/${selectedReview.logo}`}
              alt="Logo"
              className="img-fluid rounded center"
              style={{ maxHeight: "200px", objectFit: "contain" }}
            />
          )}
        </div>
        <Row className="mb-3">
          <Col xs={12} md={12} lg={6} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">
                Game Reviewed
              </span>
              <span className="d-block fs-5 fw-medium text-light">
                {selectedReview?.game_reviewed?.title || ""}
              </span>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">
                Reviewed By
              </span>
              <span className="d-block fs-5 fw-medium text-light">
                {selectedReview?.reviewed_by?.email || ""}
              </span>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Review</span>
              <span className="d-block fs-5 fw-medium text-light">
                {selectedReview?.review_text || ""}
              </span>
            </div>
          </Col>

          {Object.entries({
            Rating: selectedReview?.rating || "",
            Likes: selectedReview?.likes || 0,
            Status: selectedReview?.status || "",
            "Reviewed At":
              selectedReview?.createdAt &&
              format(selectedReview?.createdAt, "PP"),
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded" key={key}>
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium text-light">
                  {value}
                </span>
              </div>
            </Col>
          ))}
          {selectedReview?.changed_by && (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">
                  Updated by
                </span>
                <span className="d-block fs-5 fw-medium text-light">
                  {`${selectedReview?.changed_by.first_name || ""} ${selectedReview?.changed_by.last_name || ""}`}
                </span>
              </div>
            </Col>
          )}
        </Row>
        <div className="container-fluid bg-dark my-2">
          <div className="d-flex justify-content-end">
            {changing && (
              <div className="mx-2">
                <LoadingSpinner size={"lg"} />
              </div>
            )}

            {selectedReview?.status !== "pending" && (
              <Button
                disabled={changing}
                variant="info"
                className="mr-2"
                onClick={() => {
                  handleUpdateReviewStatus("pending");
                }}
              >
                Pending
              </Button>
            )}
            {selectedReview?.status !== "approved" && (
              <Button
                disabled={changing}
                variant="success"
                className="mr-2"
                onClick={() => {
                  handleUpdateReviewStatus("approved");
                }}
              >
                Approve
              </Button>
            )}
            {selectedReview?.status !== "rejected" && (
              <Button
                disabled={changing}
                variant="danger"
                className="mr-2"
                onClick={() => {
                  handleUpdateReviewStatus("rejected");
                }}
              >
                Reject
              </Button>
            )}
            <Button variant="secondary" onClick={handleCloseDetailsModal}>
              Close
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ReviewEditModal;
